import theme from '@/style';
import {View, StyleSheet} from 'react-native';
import Button from '@/components/basic/button';
import React, {ReactNode} from 'react';
import {ButtonType} from '@/components/basic/button/button';
import {useTranslation} from 'react-i18next';
import {useResponsiveDimensions} from '@/utils';
import globalStore from '@/services/global.state';
import {
  BalanceListItem,
  PayMethod,
} from '@/common-pages/recharge/recharge.service';
// import {RechargeTabItem} from '@/common-pages/recharge/recharge-tab/recharge-tab';
import {useRechargeStore} from '@/common-pages/recharge/recharge.store';
import {
  // calculateTotalBonus,
  getButtonFirstLineText,
  getButtonSecondLineText,
  getTopRightBonusText,
} from '@/common-pages/recharge/util/recharge-tab-bonus.utils';
import RechargeTip from '@/common-pages/recharge/recharge-tip';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';

export interface RechargeButtonProps {
  disabled?: boolean;
  type?: ButtonType;
  text?: string;
  balance?: string;
  payMethod?: PayMethod;
  balanceItem?: BalanceListItem;
  onRecharge?: () => void;
  receiveTip?: ReactNode;
  isWeekCard?: boolean;
  extraSent?: string;
}

const RechargeButton: React.FC<RechargeButtonProps> = ({
  type,
  onRecharge,
  disabled,
  text,
  balance,
  payMethod,
  balanceItem,
  isWeekCard,
  // receiveTip,
}) => {
  const {i18n} = useTranslation();
  const {width} = useResponsiveDimensions();
  const designWidth = 375;
  const rechargeButtonWidth = (335 * width) / designWidth;

  // 获取当前选中的recharge tab
  const {activeTabId, tabs, balanceConfig} = useRechargeStore();
  const activeTab = tabs.find(tab => tab.id === activeTabId);

  // 添加调试信息
  const {calcActualSize} = useScreenSize();

  // 计算按钮显示文本
  const buttonFirstLineText = React.useMemo(() => {
    if (!balance) {
      return undefined;
    }
    return getButtonFirstLineText(balance);
  }, [balance]);

  const buttonSecondLineText = React.useMemo(() => {
    if (!balance) {
      return undefined;
    }
    return getButtonSecondLineText(
      balance,
      payMethod,
      balanceItem,
      activeTab,
      balanceConfig,
    );
  }, [balance, payMethod, balanceItem, activeTab, balanceConfig]);

  const topRightBonusText = React.useMemo(() => {
    return getTopRightBonusText(
      activeTab,
      payMethod,
      balanceItem,
      balance,
      balanceConfig,
    );
  }, [activeTab, payMethod, balanceItem, balance, balanceConfig]);

  const rechargeStyle = StyleSheet.create({
    button: {
      width: rechargeButtonWidth,
      height: 48,
    },
    buttonWrap: {
      paddingTop: theme.paddingSize.l,
      paddingHorizontal: theme.paddingSize.l,
      paddingBottom: globalStore.isAndroid
        ? theme.paddingSize.l * 3
        : theme.paddingSize.l,
    },
    topRightTag: {
      position: 'absolute',
      top: -8,
      right: -8,
      backgroundColor: '#FF4444',
      borderRadius: 8,
      paddingHorizontal: 6,
      paddingVertical: 2,
      zIndex: 10,
    },
  });

  return (
    <View
      style={[
        theme.flex.center,
        theme.fill.fillW,
        rechargeStyle.buttonWrap,
        theme.background.white,
      ]}>
      <div style={{position: 'relative'}}>
        {topRightBonusText && (
          <RechargeTip
            style={{left: calcActualSize(149), right: 'auto'}}
            animateType="95">
            {i18n.t('recharge.tip.extra', {
              bonus: topRightBonusText,
            })}
          </RechargeTip>
        )}
        <div style={{position: 'relative'}}>
          {/* {topRightBonusText && (
            <div style={rechargeStyle.topRightTag}>
              <Text fontSize={theme.fontSize.xs} blod color="#FFEC4F">
                {topRightBonusText}
              </Text>
            </div>
          )} */}
          {isWeekCard ? (
            <Button
              size="large"
              type={type}
              disabled={disabled}
              width={rechargeButtonWidth}
              buttonStyle={[rechargeStyle.button]}
              onPress={onRecharge}>
              <span className="text-white text-sm font-bold">
                {i18n.t('home.label.rechargeWeekCard')}
              </span>
            </Button>
          ) : (
            <Button
              size="large"
              type={type}
              disabled={disabled}
              width={rechargeButtonWidth}
              buttonStyle={[rechargeStyle.button]}
              onPress={onRecharge}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}>
                {buttonFirstLineText && (
                  <span className="text-white text-sm font-bold">
                    {buttonFirstLineText}
                  </span>
                )}
                {buttonSecondLineText && (
                  <span className="text-white text-xs font-normal tracking-[-0.3px]">
                    You can get({buttonSecondLineText})
                  </span>
                )}
                {text && (
                  <span className="text-white text-sm font-bold">{text}</span>
                )}
              </div>
            </Button>
          )}
        </div>
      </div>
    </View>
  );
};

export default RechargeButton;
